(function () {
  // Second card image (box + bottle shot). Only devices with real hover ever load it: touch devices keep the first
  // image alone and download nothing extra. It starts loading when its card gets near the viewport (so the first
  // hover never flashes) or, as a fallback, on the first mouse-over of the image area.
  var HOVER = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!HOVER) return;

  function load(img) {
    if (!img || img.getAttribute('data-loaded')) return;
    img.setAttribute('data-loaded', '1');
    var srcset = img.getAttribute('data-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    var src = img.getAttribute('data-src');
    if (src) img.setAttribute('src', src);
  }

  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      observer.unobserve(e.target);
      load(e.target);
    });
  }, { rootMargin: '600px 0px' }) : null;

  function scan(root) {
    (root || document).querySelectorAll('.f-card__img-second:not([data-loaded]):not([data-watched])').forEach(function (img) {
      img.setAttribute('data-watched', '1');
      if (observer) observer.observe(img); else load(img);
    });
  }

  // Fallback / safety net: first mouse-over of the image area loads it right away.
  document.addEventListener('mouseover', function (e) {
    if (!HOVER.matches) return;
    var media = e.target.closest && e.target.closest('.f-card__media');
    if (media) load(media.querySelector('.f-card__img-second'));
  });

  document.addEventListener('fiorenci:cards-added', function () { if (HOVER.matches) scan(); });   // cards added after load (recently viewed row)
  // Start (or stop) with the device: a touch screen never loads the second image; a window that becomes hover-capable (a laptop
  // with its touch screen switched off, a tablet with a mouse attached) starts then.
  function start() { if (HOVER.matches) scan(); }
  if (HOVER.addEventListener) HOVER.addEventListener('change', start); else if (HOVER.addListener) HOVER.addListener(start);
  start();
})();
